<template lang="pug">
.mensagem.columns
  .column.col-6.col-sm-12.my-2
    div(v-if="mensagem.remetente")
      text-output(
        :label="'mensagem.remetente' | tModel",
        :text="mensagem.remetente.razao_social"
      )
    div(v-if="mensagem.destinatario")
      text-output(
        :label="'mensagem.destinatario' | tModel",
        :text="mensagem.destinatario.razao_social"
      )
  .column.col-6.col-sm-12.my-2
    text-output(
      :label="'mensagem.enviado_em' | tModel",
      :text="mensagem.enviado_em | date"
    )
    text-output(
      :label="'mensagem.leitura_em' | tModel",
      :text="mensagem.leitura_em | date"
    )
  .column.col-12.my-2
    .h4 {{ mensagem.titulo }}
  .column.col-12.divider
  .column.col-12.my-2
    .text-output.pre-wrap {{ mensagem.conteudo }}
  .links
    a.btn.btn-link(:href="anexo.url" v-for="anexo in anexos" target="_blank")
      i.fa.fa-external-link
      span {{ anexo.file_name || anexo.descricao || "Ver anexo" }}
  .column.col-12(v-for="anexo in iptuAnexos")
    router-link.btn.btn-link(:to="{ name: 'app.carnes.carne', params: { id: extractCadastroId(anexo) } }")
      i.fa.fa-external-link
      span {{ anexo.file_name || anexo.descricao || "Ver anexo" }}
</template>

<script>
import Mensagem from "@/models/Mensagem";

export default {
  props: { mensagem: { type: Mensagem, required: true } },
  computed: {
    anexosList() {
      return this.mensagem.anexos || []
    },
    iptuAnexos() {
      return (this.anexosList || []).filter(a => {
        return a.file_info && a.file_info.ext === 'folder'
      })
    },
    anexos() {
      return (this.anexosList || []).filter(a => {
        return a.file_info && a.file_info.ext !== 'folder'
      })
    }
  },
  methods: {
    extractCadastroId(anexo) {
      return anexo.file_info.path.split('/').pop()
    }
  },
};
</script>
